<template>
  <b-modal :id="id" size="md" centered title="Termin verwerfen" @hidden="onHidden">
    <div class="mb-3">
      <FeldLabel class="mb-2" :icon="labelIcons.Tag" text="Verworfen Grund" />
      <AppSelect
        v-model="grundSelected"
        sort="none"
        :options="grundOptions"
        label="Verworfen Grund"
        placeholder="Grund wählen"
        hideSearch
      />
    </div>
    <div class="mb-0">
      <FeldLabel class="mb-2" :icon="labelIcons.MessagesSquare" text="Kommentar" />
      <b-form-input v-model="kommentar"></b-form-input>
    </div>
    <template #modal-footer="{ hide }">
      <b-button class="dialog-btn-secondary" @click="hide">Abbrechen</b-button>
      <b-button class="dialog-btn dialog-btn--verwerfen" :disabled="!grundSelected" @click="onConfirm(hide)">
        Verwerfen
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { grundOptions } from '@/core/common/helpers/utils';
import AppSelect from '@/components/common/app-select/app-select.vue';
import FeldLabel from '@/components/common/feld-label.vue';
import { Tag, MessagesSquare } from 'lucide-vue';

export default {
  name: 'ModalTerminVerwerfen',
  components: { AppSelect, FeldLabel },
  props: {
    id: { type: String, required: true },
  },
  data() {
    return {
      labelIcons: Object.freeze({ Tag, MessagesSquare }),
      grundOptions,
      grundSelected: null,
      kommentar: null,
    };
  },
  methods: {
    onHidden() {
      this.grundSelected = null;
      this.kommentar = null;
    },
    onConfirm(hide) {
      this.$emit('verwerfen', { grund: this.grundSelected, kommentar: this.kommentar });
      hide();
    },
  },
};
</script>

<style scoped>
.btn.dialog-btn--verwerfen:not(:disabled):not(.disabled) {
  background-color: var(--danger-confirm);
  border-color: var(--danger-confirm);
  color: var(--surface);
}

.btn.dialog-btn--verwerfen:not(:disabled):not(.disabled):hover,
.btn.dialog-btn--verwerfen:not(:disabled):not(.disabled):focus,
.btn.dialog-btn--verwerfen:not(:disabled):not(.disabled):active {
  background-color: var(--danger-confirm-hover);
  border-color: var(--danger-confirm-hover);
  color: var(--surface);
  box-shadow: none;
}
</style>
